<template>
  <div>
    <b-modal id="modal-input" size="lg" centered :title="$store.state.modal.tambahAsuransi" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group :label="$store.state.form.judul" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('title')" v-model="$v.data.title.$model" autofocus></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.target" label-cols-md="3">
          <b-form-select :options="targetOptions" v-model="$v.data.target.$model" :state="checkIfValid('target')"></b-form-select>
        </b-form-group>

        <b-form-group v-if="data.target === 'user'" :label="$store.state.form.user" label-cols-md="3">
          <b-form-select :options="userOptions" v-model="$v.data.user.$model" :state="checkIfValid('user')"></b-form-select>
        </b-form-group>

        <b-form-group :label="$store.state.form.file" label-cols-md="3">
          <b-form-file v-model="data.file" :state="checkIfValid('file')" browse-text="Pilih File" placeholder="Pilih atau seret file ke sini..."></b-form-file>
        </b-form-group>

        <b-form-group :label="$store.state.form.broadcastDate" label-cols-md="3">
          <b-form-datepicker v-model="$v.data.broadcastDate.$model" :state="checkIfValid('broadcastDate')" reset-button locale="id"></b-form-datepicker>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "modalInput",
  data() {
    return {
      data: {
        title: "",
        target: "",
        user: "",
        file: null,
        broadcastDate: null,
      },
      busy: false,
      button: "Simpan",
      targetOptions: [
        { value: "all", text: "All" },
        { value: "user", text: "User" },
        { value: "division", text: "Division" },
      ],
      userOptions: [
        { value: "user1", text: "User 1" },
        { value: "user2", text: "User 2" },
      ],
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    isValid() {
      return !this.$v.data.$invalid;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      title: { required },
      target: { required },
      user: {
        required(value, vm) {
          return vm.data.target !== "user" || !!value;
        },
      },
      file: { required },
      broadcastDate: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) return null;
      return !field.$invalid;
    },
    simpan() {
      if (!this.isValid) return;
      this.busy = true;
      this.button = this.$store.state.form.tunggu;

      const formData = new FormData();
      formData.append("title", this.data.title);
      formData.append("target", this.data.target);
      if (this.data.target === "user") {
        formData.append("user", this.data.user);
      }
      formData.append("file", this.data.file);
      formData.append("broadcastDate", this.data.broadcastDate);

      this.$axios
        .post("broadcast/register", formData)
        .then((res) => {
          this.$emit("alertFromChild", {
            variant: res.data.message === "sukses" ? "success" : "danger",
            msg: res.data.message === "sukses" ? "BERHASIL MENDAFTARKAN BROADCAST" : res.data.message.toUpperCase(),
            showing: true,
          });
          this.resetForm();
          this.$bvModal.hide("modal-input");
        })
        .catch((err) => {
          this.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        })
        .finally(() => {
          this.busy = false;
          this.button = this.$store.state.form.simpan;
        });
    },
    resetForm() {
      this.data = {
        title: "",
        target: "",
        user: "",
        file: null,
        broadcastDate: null,
      };
      this.$v.$reset();
    },
  },
  watch: {
    lang() {
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
